import { useState } from 'react';
import { EMOTES, t } from '@kadice/shared';
import type { GameClient } from '../useGameClient';

/**
 * The 😀 button beside Chat; its menu (opening upward, kept on screen) sends one emote to the
 * table. `className` places it: the peek strip on narrower screens, the chat form on wide ones.
 */
export function EmotePicker({ client, className }: { client: GameClient; className?: string }) {
  const [open, setOpen] = useState(false);
  const send = (emote: (typeof EMOTES)[number]) => {
    setOpen(false);
    void client.request('emote:send', { emote });
  };
  return (
    <span className={`emote-picker${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        title={t('emote.button')}
        aria-label={t('emote.button')}
        className="icon-btn"
      >
        😀
      </button>
      {open && (
        <span className="emote-menu" role="menu">
          {EMOTES.map((e) => (
            <button key={e} type="button" role="menuitem" onClick={() => send(e)}>
              {t(`emote.${e}`)}
            </button>
          ))}
        </span>
      )}
    </span>
  );
}
